/* eslint-disable @typescript-eslint/naming-convention */
import styled from 'styled-components'
import { Button, Card, Empty, Select, Typography } from 'antd'
import { IconFont, SvgIcon } from '@/components'
import { useEffect, useState } from 'react'
import { DetailFile, useGetResource, useUpdateInterceptStatus } from './utils'
import emptyImg from '@/assets/imges/Empty/Empty.png'
import modecard from '@/assets/imges/data-protection/modecard.png'
import { GetResource } from '@/api/data-protection/task-detail'
import { CorrectedDataProps } from '@/pages/endpoint-security/task-detail/index'
import { t } from '@/i18n'

interface IDetailInfo {
  id: string | undefined
  task_id: string
  random: number
  taskInfo: any
  changeDate: (val?: any) => void
}

const defaultFileType: any = []
const defaultCompressType: any = []
const defaultLeakType: any = []

export const fileTypeMap = new Map([
  [1, 'TXT'],
  [2, 'DOCX'],
  [3, 'PDF'],
  [4, 'XLS'],
  [5, 'XLSX'],
])

export const compressTypeMap = new Map([
  [1, 'ZIP'],
  [2, '7z'],
  [3, 'tar'],
  [4, 'gz'],
  [5, t('zip加密')],
  [6, t('7z加密')],
])

export const leakTypeMap = new Map([
  [1, 'HTTP'],
  [2, 'HTTPS'],
  [3, 'GIT'],
])

const { Option } = Select

const DetailInfo: React.FC<IDetailInfo> = ({ id, task_id, random, taskInfo, changeDate }) => {
  const [resourceParams, setResourceParams] = useState<GetResource>({
    task_id: task_id,
    result_id: id,
    file_format: '',
    compress_type: '',
    leak_type: '',
  })
  const [resource, manual_correct_count, getResource] = useGetResource()
  const [updateResourceInterceptStatus, updateResourceInterceptStatusLoading] =
    useUpdateInterceptStatus()

  useEffect(() => {
    if (random !== 0) {
      getResource(resourceParams).catch(_ => {})
    }
  }, [random])

  useEffect(() => {
    if (resourceParams.task_id) {
      getResource(resourceParams)
        .then(res => {
          const arr = res.data.items.map(item => ({
            resourceId: item.id,
            interceptStatus:
              item.protect_status === 1
                ? 'protect_status_protect_success'
                : 'protect_status_protect_fail',
            prevInterceptStatus:
              item.protect_status === 1
                ? 'protect_status_protect_success'
                : 'protect_status_protect_fail',
            editable: false,
          }))
          setCorrectedData(arr)
        })
        .catch(_ => {})
    }
  }, [resourceParams])

  const [protectType, setProtectType] = useState<number>()
  const [FileType, setFileType] = useState<number[]>(defaultFileType)
  const [CompressType, setCompressType] = useState<number[]>(defaultCompressType)
  const [LeakType, setLeakType] = useState<number[]>(defaultLeakType)
  const [correctedData, setCorrectedData] = useState<CorrectedDataProps[]>([])
  console.log('correctedData', correctedData)
  const [isEdit, setIsEdit] = useState(false)

  useEffect(() => {
    if (FileType.length !== 6 && FileType.length !== 0) {
      setResourceParams(origin => ({
        ...origin,
        file_format: FileType.join(','),
      }))
    }
    if (CompressType.length !== 8 && CompressType.length !== 0) {
      setResourceParams(origin => ({
        ...origin,
        compress_type: CompressType.join(','),
      }))
    }
    if (LeakType.length !== 4 && LeakType.length !== 0) {
      setResourceParams(origin => ({
        ...origin,
        leak_type: LeakType.join(','),
      }))
    }
  }, [FileType, CompressType, LeakType])

  const handleCancel = () => {
    setIsEdit(false)
    const arr = correctedData.map(item => ({
      ...item,
      interceptStatus: item.prevInterceptStatus,
      editable: false,
    }))
    setCorrectedData(arr)
  }

  const handleCorrect = () => {
    updateResourceInterceptStatus({
      id,
      list: {
        taskResultResourceList: correctedData
          .filter(item => item.isCorrected)
          .map(item => ({
            resourceId: item.resourceId,
            protectStatus: item.interceptStatus,
          })),
      },
    })
      .then(() => {
        setIsEdit(false)
        changeDate(id)
        getResource(resourceParams)
          .then(res => {
            const arr = res.data.items.map(item => ({
              resourceId: item.id,
              interceptStatus:
                item.protect_status === 1
                  ? 'protect_status_protect_success'
                  : 'protect_status_protect_fail',
              prevInterceptStatus:
                item.protect_status === 1
                  ? 'protect_status_protect_success'
                  : 'protect_status_protect_fail',
              editable: false,
            }))
            setCorrectedData(arr)
          })
          .catch(_ => {})
      })
      .catch(() => {})
  }

  const handleSelectChange = (value: number, type: string) => {
    if (value === -1 || eval(type).length === eval(`(default${type})`).length - 2) {
      eval(`set${type}(default${type})`)
      return
    }
    eval(`set${type}(${origin => [...origin, value]})`)
  }

  const handleDeselectChange = (value: any, type: string) => {
    if (value === -1) {
      eval(`set${type}([])`)
      return
    }
    if (eval(type).length === eval(`(default${type})`).length) {
      eval(`set${type}(${origin => [...origin.filter(i => i !== -1 && i !== value)]})`)
      return
    }
    eval(`set${type}(${origin => [...origin.filter(i => i !== value)]})`)
  }

  const ListItem = (prop: DetailFile) => {
    const {
      id: itemId,
      protect_status,
      file_format_type,
      compress_type,
      leak_type,
      send_file_hash,
      received_file_hash,
      file_status,
      abnormal_reason,
    } = prop

    return (
      <Item
        status={
          correctedData.find(item => item.resourceId === itemId)?.interceptStatus ===
          'protect_status_protect_success'
        }
        emptyImg={modecard}
      >
        {file_status === 1 ? (
          <>
            <div className="top">
              <SvgIcon
                className="svg-icon"
                name={`${
                  correctedData.find(item => item.resourceId === itemId)?.interceptStatus ===
                  'protect_status_protect_success'
                    ? 'protection_succeeded'
                    : 'protection_failed'
                }`}
              />
              <div className="top-right">
                {correctedData.find(item => item.resourceId === itemId)?.editable ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Select
                      value={
                        correctedData.find(item => item.resourceId === itemId)?.interceptStatus ||
                        ''
                      }
                      style={{ width: '160px', marginRight: '10px' }}
                      options={[
                        { label: t('保护成功'), value: 'protect_status_protect_success' },
                        { label: t('保护失败'), value: 'protect_status_protect_fail' },
                      ]}
                      onChange={e => {
                        const arr = correctedData.map(item =>
                          item.resourceId === itemId ? { ...item, interceptStatus: e } : item,
                        )
                        setCorrectedData(arr)
                      }}
                    />
                    <IconFont
                      type="icon-cuowutishi"
                      style={{ marginRight: '8px' }}
                      onClick={() => {
                        const arr = correctedData.map(item =>
                          item.resourceId === itemId
                            ? {
                                ...item,
                                interceptStatus: item.prevInterceptStatus,
                                editable: false,
                              }
                            : item,
                        )
                        setCorrectedData(arr)
                      }}
                    />
                    <IconFont
                      type="icon-shengchandacheng-"
                      onClick={() => {
                        const arr = correctedData.map(item =>
                          item.resourceId === itemId
                            ? { ...item, editable: false, isCorrected: true }
                            : item,
                        )
                        setCorrectedData(arr)
                      }}
                    />
                  </div>
                ) : (
                  <div style={{ display: 'flex' }}>
                    <div className="status">
                      {`${t('保护')}${
                        correctedData.find(item => item.resourceId === itemId)?.interceptStatus ===
                        'protect_status_protect_success'
                          ? t('成功')
                          : t('失败')
                      }`}
                    </div>
                    {isEdit && (
                      <IconFont
                        type="icon-huabanfuben"
                        style={{ marginLeft: '8px', cursor: 'pointer' }}
                        onClick={() => {
                          console.log('edit', itemId)
                          const arr = correctedData.map(item =>
                            item.resourceId === itemId ? { ...item, editable: true } : item,
                          )
                          setCorrectedData(arr)
                        }}
                      />
                    )}
                  </div>
                )}
                <div className="card">
                  <div className="text">
                    <Typography.Text
                      ellipsis={{ tooltip: true }}
                      style={{ width: 40, textAlign: 'center' }}
                    >
                      {file_format_type || '-'}
                    </Typography.Text>
                    <Typography.Text
                      ellipsis={{ tooltip: true }}
                      style={{ width: 40, textAlign: 'center' }}
                    >
                      {compress_type ? compressTypeMap.get(compress_type) || compress_type : '-'}
                    </Typography.Text>
                    <Typography.Text
                      ellipsis={{ tooltip: true }}
                      style={{ width: 40, textAlign: 'center' }}
                    >
                      {leak_type ? leakTypeMap.get(leak_type) || leak_type : '-'}
                    </Typography.Text>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <div style={{ marginTop: '6px' }}>
                <span className="title">{t('原始')}</span>
                <span style={{ width: 300, wordBreak: 'break-all', lineHeight: '20px' }}>
                  SHA-256:
                  <span style={{ color: '#666666', paddingLeft: '4px', marginBottom: '7px' }}>
                    {send_file_hash}
                  </span>
                </span>
              </div>
              <div>
                <span className="receive">{t('接收')}</span>
                <span style={{ width: 300, wordBreak: 'break-all', lineHeight: '20px' }}>
                  SHA-256:
                  <span style={{ color: '#666666', paddingLeft: '4px', marginBottom: '7px' }}>
                    {received_file_hash}
                  </span>
                </span>
              </div>
            </div>
            <div className="explain">
              <div style={{ padding: 10, height: 52 }}>
                <Typography.Paragraph
                  ellipsis={{
                    tooltip: `${t('说明：原始文件和接收文件SHA-256')}${
                      protect_status === 1 ? t('不同') : t('相同')
                    }${t('，以')}${taskInfo?.template_name}${t(
                      '生成的敏感数据',
                    )}${id}${file_format_type}.${
                      compressTypeMap.get(compress_type)
                        ? `.${compressTypeMap.get(compress_type)}`
                        : ''
                    }${t('通过')}${leakTypeMap.get(leak_type)}${t('外泄')}${
                      protect_status === 1 ? t('失败') : t('成功')
                    }`,
                    rows: 2,
                  }}
                >
                  <div style={{ color: '#86909C', lineHeight: '16px' }}>
                    {`${t('说明：原始文件和接收文件SHA-256')}${
                      protect_status === 1 ? t('不同') : t('相同')
                    }${t('，以')}${taskInfo?.template_name}${t(
                      '生成的敏感数据',
                    )}${id}.${file_format_type}${
                      compressTypeMap.get(compress_type)
                        ? `.${compressTypeMap.get(compress_type)}`
                        : ''
                    }${t('通过')}${leakTypeMap.get(leak_type)}${t('外泄')}${
                      protect_status === 1 ? t('失败') : t('成功')
                    }`}
                  </div>
                </Typography.Paragraph>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="top">
              <SvgIcon className="svg-icon" name={'创建失败'} />
              <div className="top-right">
                <div className="status" style={{ background: '#FDE5E5', color: '#F44F4F' }}>
                  {t('创建失败')}
                </div>
                <div className="card">
                  <div className="text">
                    <Typography.Text
                      ellipsis={{ tooltip: true }}
                      style={{ width: 40, textAlign: 'center' }}
                    >
                      {file_format_type || '-'}
                    </Typography.Text>
                    <Typography.Text
                      ellipsis={{ tooltip: true }}
                      style={{ width: 40, textAlign: 'center' }}
                    >
                      {compress_type ? compressTypeMap.get(compress_type) || compress_type : '-'}
                    </Typography.Text>
                    <Typography.Text
                      ellipsis={{ tooltip: true }}
                      style={{ width: 40, textAlign: 'center' }}
                    >
                      {leak_type ? leakTypeMap.get(leak_type) || leak_type : '-'}
                    </Typography.Text>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <div style={{ marginTop: '6px' }}>
                <Typography.Paragraph
                  ellipsis={{
                    tooltip: abnormal_reason,
                    rows: 6,
                  }}
                >
                  <span style={{ fontSize: '12px', fontWeight: '400', color: '#333333' }}>
                    {t('创建失败原因：')}
                  </span>
                  <span style={{ width: 300, wordBreak: 'break-all', lineHeight: '20px' }}>
                    {abnormal_reason}
                  </span>
                </Typography.Paragraph>
              </div>
            </div>
          </>
        )}
      </Item>
    )
  }

  return (
    <DetailInfoCard
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{t('详情信息')}</span>
          {[3, 4].includes(taskInfo?.is_finished) && (
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  color: '#666666',
                  marginRight: 16,
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '32px',
                }}
              >
                {t('已修正')}
                <span style={{ margin: '0 2px', color: '#2090A8' }}>{manual_correct_count}</span>
                {t('项')}
              </div>
              {isEdit ? (
                <div>
                  <Button onClick={handleCancel} style={{ marginRight: '10px' }}>
                    {t('取消')}
                  </Button>
                  <Button
                    type="primary"
                    onClick={handleCorrect}
                    loading={updateResourceInterceptStatusLoading}
                  >
                    {t('确定')}
                  </Button>
                </div>
              ) : (
                <Button
                  type="primary"
                  onClick={() => {
                    setIsEdit(true)
                  }}
                >
                  {t('批量修正')}
                </Button>
              )}
            </div>
          )}
        </div>
      }
    >
      <ToolBar>
        <div className="item">
          <div className="select">
            <Select
              allowClear
              placeholder={t('保护结果')}
              value={protectType}
              style={{ width: '100%' }}
              onChange={e => {
                setProtectType(e)
                setResourceParams({ ...resourceParams, protect_status: e })
              }}
            >
              <Option value={1}>{t('保护成功')}</Option>
              <Option value={2}>{t('保护失败')}</Option>
            </Select>
          </div>
        </div>
        <div className="item">
          <div className="select">
            <Select
              allowClear
              placeholder={t('文件格式')}
              style={{ width: '100%' }}
              value={FileType}
              onClear={() => {
                setFileType([])
              }}
              onSelect={(value: number) => handleSelectChange(value, 'FileType')}
              onDeselect={(value: any) => handleDeselectChange(value, 'FileType')}
              mode="multiple"
              maxTagCount={2}
              maxTagTextLength={3}
              showSearch={false}
            >
              <Option value={1}>TXT</Option>
              <Option value={2}>DOCX</Option>
              <Option value={3}>PDF</Option>
              <Option value={4}>XLS</Option>
              <Option value={5}>XLSX</Option>
            </Select>
          </div>
        </div>
        <div className="item">
          <div className="select">
            <Select
              allowClear
              placeholder={t('压缩嵌套')}
              style={{ width: '100%' }}
              value={CompressType}
              onClear={() => {
                setCompressType(defaultCompressType)
              }}
              onSelect={value => handleSelectChange(value, 'CompressType')}
              onDeselect={(value: any) => handleDeselectChange(value, 'CompressType')}
              mode="multiple"
              maxTagCount={2}
              maxTagTextLength={3}
              showSearch={false}
            >
              <Option value={1}>ZIP</Option>
              <Option value={2}>7z</Option>
              <Option value={3}>tar</Option>
              <Option value={4}>gz</Option>
              <Option value={5}>{t('zip加密')}</Option>
              <Option value={6}>{t('7z加密')}</Option>
            </Select>
          </div>
        </div>
        <div className="item">
          <div className="select">
            <Select
              allowClear
              placeholder={t('外泄途径')}
              style={{ width: '100%' }}
              onClear={() => {
                setLeakType(defaultLeakType)
              }}
              value={LeakType}
              onSelect={value => handleSelectChange(value, 'LeakType')}
              onDeselect={(value: any) => handleDeselectChange(value, 'LeakType')}
              mode="multiple"
              maxTagCount={2}
              maxTagTextLength={3}
              showSearch={false}
            >
              <Option value={1}>HTTP</Option>
              <Option value={2}>HTTPS</Option>
              <Option value={3}>GIT</Option>
            </Select>
          </div>
        </div>
        <Button
          type="link"
          style={{ paddingLeft: 0 }}
          onClick={() => {
            setResourceParams({
              task_id: task_id,
              result_id: id,
              file_format: defaultFileType,
              compress_type: defaultCompressType,
              leak_type: defaultLeakType,
            })
            setProtectType(undefined)
            setCompressType(defaultCompressType)
            setFileType(defaultFileType)
            setLeakType(defaultLeakType)
          }}
        >
          {t('重置')}
        </Button>
      </ToolBar>
      {resource?.length > 0 ? (
        <List>
          {resource?.map((item, index) => (
            <ListItem key={index} {...item} />
          ))}
        </List>
      ) : (
        <Empty image={emptyImg} />
      )}
    </DetailInfoCard>
  )
}

const DetailInfoCard = styled(Card)`
  margin-top: 16px;
`

const ToolBar = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
  .item {
    display: flex;
    flex: 1;
    align-items: center;
  }
  .select {
    width: 100%;
    .ant-select-selection-item {
      padding-left: 3px;
      margin-left: 2px;
      align-items: center;
    }
  }
`

const List = styled.div`
  width: 100%;
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, minmax(347px, 1fr));
  grid-gap: 0 20px;
`
interface IItem {
  status: boolean
}
const Item = styled.div<IItem>`
  width: 347px;
  height: 230px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  .top {
    margin-top: 12px;
    display: flex;
    width: 90%;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px 0 8px;
    .svg-icon {
      width: 48px;
      height: 56px;
    }
    .top-right {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 228px;
      margin-bottom: 10px;
      .status {
        width: 68px;
        height: 24px;
        background: ${(props: IItem) => (props.status ? '#E5EEFF' : '#FDE5E5')};
        border-radius: 4px 12px 4px 12px;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: ${(props: IItem) => (props.status ? '#2973FF' : '#F44F4F')};
        line-height: 24px;
      }
      .card {
        height: 24px;
        .text {
          position: absolute;
          z-index: 1;
          height: 24px;
          width: 233px;
          display: flex;
          justify-content: space-around;
          background: url(${props => props.emptyImg}) no-repeat;
          background-size: 100% 100%;
        }
        span {
          font-size: 12px;
          font-weight: 400;
          color: #4238c9;
          line-height: 24px;
        }
      }
    }
  }
  .bottom {
    width: 307px;
    height: 130px;
    background: #f7f7f9;
    font-size: 12px;
    border-radius: 6px;
    margin-bottom: 8px;
    padding: 0 8px 0 8px;
    .title,
    .receive {
      padding: 0 2px 0 2px;
      margin-right: 3px;
      width: 30px;
      height: 18px;
      line-height: 15px;
      border-radius: 3px;
      border: 1px solid #999999;
      color: #666666;
      text-align: center;
    }
    .receive {
      border: 1px solid ${(props: IItem) => (props.status ? '#2973FF' : '#F44F4F')};
      color: ${(props: IItem) => (props.status ? '#2973FF' : '#F44F4F')};
    }
  }
  .explain {
    width: 100%;
    border-top: 1px dashed #d5d9dd;
    font-size: 12px;
    color: #86909c;
  }
`

export default DetailInfo
